module.exports = __webpack_public_path__ + "static/media/proj13.6ed91918.PNG";